<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="users"
              :items-per-page="50"
              item-key="id"
              sort-by="user"
              class="elevation-1"
              show-expand
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Users</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New User</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.username" label="Username"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.surname" label="Surname"></v-text-field>
                            </v-flex>                             
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="editedItem.title" label="Title"></v-text-field>
                            </v-flex> 
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-if="editedIndex < 0"  v-model="editedItem.password" label="Password"></v-text-field>
                            </v-flex>                                                                                                                                                                
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="roleDialog" max-width="300px">                    
                    <v-card>
                      <v-card-title>
                        <span class="headline">Add Role</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                                      
                            <v-flex xs12 sm6 md6>   
                              <v-combobox
                                :items="roles"
                                label="Select Role"
                                v-model="editedRole"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>                         
                            </v-flex>                                                                                                                                                                                     
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="closeRoleDialog">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="saveRole">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:expanded-item="{ headers, item: masterItem }">
                <td :colspan="headers.length" >                  
                  <v-layout row wrap>   
                    <v-flex xs12/>
                    <v-flex xs3>
                      Roles of {{ masterItem.username }}                    
                    </v-flex>
                    <v-flex xs9>                       
                    </v-flex>
                    <v-flex xs12>


                      <v-data-table
                      :headers="rolesHeaders"
                      :items="masterItem.roles"
                      :items-per-page="5"
                      item-key="id"
                      sort-by="transfersDate"
                      :sort-desc=true
                      class="elevation-1"
                      >                      
                      <template v-slot:body.append>                    
                      </template>             
                      <template v-slot:item.roleAction="{ item }">              
                        <v-icon                  
                          @click="deleteRoleItem(item,masterItem)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>

                    </v-flex>
                  </v-layout>
                </td>                
              </template>
              <template v-slot:body.append>                    
              </template>           
              <template v-slot:item.addrole="{ item }">              
                <v-icon                  
                  @click="addrole(item)">
                  mdi-plus-circle-outline
                </v-icon>               
              </template>   
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
const API_URL = 'users';
export default {
    components:{
      LeftMenu
    },
    data () {
    return {
      dialog: false,
      roleDialog : false,
      editedRoleUser: {},
      editedRole : { text:''},
      search: '',
      roles: [],
      users: [
        {     
          name: '',
          surname: '',
          email: '',           
        },               
      ],
      editedIndex: -1,
      editedItem: {
        model: '',
          name: '',
          surname: '',
          email: '', 
      },
      defaultItem: {
        model: '',
          name: '',
          surname: '',
          email: '', 
      },
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Add Role',  value: 'addrole'  },     
        {
          text: 'Username',
          align: 'left',
          sortable: true,
          value: 'username',
        },
        { text: 'Name',  value: 'name'  },
        { text: 'Surname',  value: 'surname'  },        
        { text: 'Email',  value: 'email'  },
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    rolesHeaders () {
      return [
        { text: 'Role Name',  value: 'text'  },        
        { text: 'Role Actions', value: 'roleAction', sortable: false },
      ]
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New User' : 'Edit User'
    },
  },
  created() {    
    this.getUsers();
    this.getRoles();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    addrole(item){ 
      this.editedRoleUser = Object.assign({}, item)
      this.roleDialog = true
    }, 
    closeRoleDialog(){
      this.roleDialog = false
    },
    saveRole(){
      if(this.editedRole){
        this.$axios.post(this.$apiurl + API_URL+'/roles/addnew/'+this.editedRoleUser.id+'/'+this.editedRole.id, {})
        .then(response => {        
          if (response.status === 201) {
            this.getUsers();
            this.closeRoleDialog();
          } 
        }) 
        .catch(error => {
          console.log(error);
        }); 
      }
    },
    editItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.users.indexOf(item)
      if(confirm('Are you sure you want to delete this user?')){
        this.users.splice(index, 1);
        this.deleteUser(item);
      } 
    },
    deleteRoleItem (item, masterItem) {
      console.log(item);
      console.log(masterItem);
      const index = masterItem.roles.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        masterItem.roles.splice(index, 1);
        this.deleteRole(item,masterItem);
      } 
    },
    deleteRole(item, masterItem){
      this.$axios.delete(this.$apiurl + 'users/'+masterItem.id+'/roles/'+item.id)
      .then(response => {
        if (response.status === 200) {
          this.getUsers();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updateUser(this.editedItem);
      } else {
        this.addUser(this.editedItem);         
      }      
    },
    addUser(item){
      this.$axios.post(this.$apiurl + API_URL+'/signup', {
        username: item.username,
        email: item.email,
        name: item.name,        
        surname: item.surname,
        password: item.password,
        title: item.title,
      })
      .then(response => {        
        if (response.status === 201) {
          this.getUsers();
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateUser(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        username: item.username,
        email: item.email,
        name: item.name,
        surname: item.surname,
        password: item.password,
        title: item.title,
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.users[this.editedIndex], this.editedItem);
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteUser(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getUsers(){     
        this.$axios.get(this.$apiurl + API_URL)
            .then(response => {
                this.users = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getRoles(){     
        this.$axios.get(this.$apiurl + "roles/all")
            .then(response => {
                this.roles = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
